import { createI18n } from "vue-i18n";
import en from "./json/en.json";
import ja from "./json/ja.json";

const i18n = createI18n({
  messages: {
    en: en,
    ja: ja,
  },
  locale: "en",
  legacy: false,
  fallbackLocale: "en",
  globalInjection: true,
});

export default i18n;
